import { Action as ReduxAction } from 'redux';

import { AppState } from '../../../../app/state/AppState';
import { Messages } from '../../../../codegen/Localize';
import { ICollectionInfo } from '../../../../Collections/space/ICollectionInfo';
import { FeatureFlags } from '../../../../ts/FeatureFlags';
import { openContentDetailDialog } from '../../../actions/OpenContentDetailDialogActions';
import { isSingleCollectionSpace } from '../../../state/SpaceInfo';
import { EntityActionNames, IEntityAction } from './IEntityAction';

export const CollectionDetailsAction: IEntityAction<ICollectionInfo, {}> = {
  name: EntityActionNames.CollectionDetails,
  translateName: Messages.collectionsDetailsMenu,
  isVisible: (_targetItems: ICollectionInfo[], state: AppState) => {
    return FeatureFlags.collectionsEnabled && isSingleCollectionSpace(state.spaceInfo);
  },
  isClickable: (_availableActions: {}, targetItems: ICollectionInfo[]) => {
    if(targetItems.length !== 1) return false;

    const item = targetItems[0];
    return item.contentType === 'collection';
  },
  createReduxAction: (targetItems: ICollectionInfo[]): ReduxAction => {
    return openContentDetailDialog(targetItems[0]);
  },
};

